<template>
  <section class="is-flex">
    <FormMultiSelect
      v-model="filter.operator"
      :config="textQueryOperatorConfig"
      :show-float-label="false"
      :rules="{ required: true }"
      :data-e2e="TableCypressAttribute.filter.inputs.OPERATORS"
    />
    <div class="m-l-10">
      <FormInput
        v-model="filter.value"
        type="text"
        :rules="{ required: true }"
        :placeholder="$t('core.value')"
        :data-e2e="TableCypressAttribute.filter.inputs.VALUE_FORM_ELEMENT"
      />
    </div>
  </section>
</template>

<script>
import { UrlQueryOperator } from '/@/modules/core/app/constants/UrlQueryOperator';
import FormInput from '/@/modules/core/form/components/FormInput.vue';
import FormMultiSelect from '/@/modules/core/form/components/FormMultiSelect.vue';
import { FormSelectConfig } from '/@/modules/core/form/models/FormSelectConfig';
import { TableCypressAttribute } from '/@/modules/core/table/constants/TableCypressAttribute';
import { TableFilter } from '/@/modules/core/table/models/TableFilter';

export default {
  compatConfig: {
    COMPONENT_V_MODEL: true
  },
  name: 'TextTableFilter',
  components: { FormInput, FormMultiSelect },
  props: {
    tableFilter: {
      type: TableFilter,
      required: true
    }
  },
  static: {
    TableCypressAttribute
  },
  data() {
    return {
      filter: this.tableFilter,
      value: null,
      textQueryOperatorConfig: new FormSelectConfig({
        options: [UrlQueryOperator.EQUAL_TO, UrlQueryOperator.CONTAINS]
      })
    };
  }
};
</script>
